import {
  Button,
  Table,
  Modal,
  Popconfirm,
  SuccessNotification,
  message
} from "components/common";
import React, { useState } from "react";
import { Wrapper } from "./ExpenseCategories.styled";
import { DeleteOutlined } from "@ant-design/icons";
import DeleteCategoryModal from "components/pageSection/ExpenseCategories/DeleteCategory/DeleteCategoryModal";
import AddExpenseCategory from "components/pageSection/ExpenseCategories/AddExpenseCategory/AddExpenseCategory";
import { callDeleteApi, callGetApi, callPostApi } from "utils/api";
import { useEffect } from "react";
import { getUserPermissions } from "utils/text";

const ExpenseCategories = () => {
  const initialVaue = { name: "" };
  const [formData, setFormData] = useState(initialVaue);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isAddModal, setIsAddModal] = useState(false);
  const [expenseData, setExpenseData] = useState([]);
  const [expenseName, setExpenseName] = useState([]);
  const [expenseCount, setExpenseCount] = useState(0);
  const [expenseId, setExpenseId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isADDLoading, setIsAddLoading] = useState(false);

  const Columns = [
    {
      title: "Category Name",
      dataIndex: "name",
    },

    {
      title: "Action",
      render: (_, items) => (
        <a>
          {getUserPermissions("expense-delete-action") && (
            <Popconfirm
              title="Are you sure you want to delete?"
              onConfirm={() => {
                setExpenseId(items?._id);
                setExpenseName(items?.name);
                deleteExpense(items?._id);
              }}
            >
              <DeleteOutlined />
            </Popconfirm>
          )}
        </a>
      ),
    },
  ];


  const callGetExpenseApi = () => {
    callGetApi("/expenses-category", (data) => {
      setIsLoading(false);
      setExpenseData(data);
    }, (err) => {
      console.log(err);
      setIsLoading(false);
    });
  };
  const callPostAddExpenseApi = (data) => {
    setIsAddLoading(true);

    callPostApi(
      "/expenses-category",
      data,
      (data) => {
        SuccessNotification("Expense Category Added");
        setIsAddLoading(false);
        setFormData(formData);
        callGetExpenseApi();
      },
      (err) => {
        setIsAddLoading(false);
        console.log(err);
      }
    );
  };
  const deleteExpense = (id) => {
    callDeleteApi(`/expenses-category/${id}`, (data) => {
      if (data.isDeleted) {
        SuccessNotification("Expense Category Deleted");
        callGetExpenseApi();
      } else {
        setIsDeleteModal(true);
        setExpenseCount(data);
      }
    }, (err) => {
      console.log(err);
    });
  };

  useEffect(() => {
    setIsLoading(true);
    callGetExpenseApi();
  }, []);

  return (
    <Wrapper>
      <Table
        loading={isLoading}
        columns={Columns}
        dataSource={expenseData}
        pagination={true}
        header
        headerTitle="Expense Categories"
        button
        button1={
          getUserPermissions("add-new-expense-category-action") && (
            <Button
              className="button-container"
              AddIcon
              title="Add New Expense Category"
              onClick={() => {
                setIsAddModal(true);
                setFormData({
                  ...formData,
                  name: "",
                });
              }}
            />
          )
        }
      />
      <Modal
        title="Add New Expense Category"
        isOpen={isAddModal}
        toggleModal={() => setIsAddModal(false)}
        onOk={() => {
          if (formData?.name) {
            setIsAddLoading(true);
            callPostAddExpenseApi(formData);
            setIsAddModal(false);
          } else {
            message.error("Please enter category name")
          }
        }}
      >
        <AddExpenseCategory formData={formData} setFormData={setFormData} />
      </Modal>

      <Modal
        footer={false}
        title={`${expenseCount} Payments currently have their category set to ${expenseName}.
         You must change the  category  of these Payments before continuing.`}
        isOpen={isDeleteModal}
        toggleModal={() => setIsDeleteModal(false)}
      >
        <DeleteCategoryModal
          expenseData={expenseData}
          expenseId={expenseId}
          callGetExpenseApi={callGetExpenseApi}
          setIsDeleteModal={setIsDeleteModal}
        />
      </Modal>
    </Wrapper>
  );
};

export default ExpenseCategories;
